<template>
  <app-ag-grid
    title="Customers"
    :columnDefs="columnDefs"
    :rowData="customers"
    :loading="loading"
    :mobileCard="mobileCard"
    @refresh="fetchCustomers"
    @add="onAdd"
    @row-dbl-click="
      (data) => $router.push({ path: `customers/${data._id}/edit` })
    "
  ></app-ag-grid>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "CustomersPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,

      columnDefs: [
        {
          headerName: "View Invoices",
          field: "_id",
          width: 120,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-customer-invoices"
                data-id="${params.data._id}"
                title="View Customer Invoices"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (
              params.event.target.classList.contains("view-customer-invoices")
            ) {
              this.$router.push({ path: `customers/${params.data._id}/invoices` });
            }
          },
        },
        {
          headerName: "Customer Name",
          field: "name",
          minWidth: 180,
        },

        {
          headerName: "Phone",
          field: "phone",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "Email",
          field: "email",
          minWidth: 220,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "GSTIN",
          field: "gstin",
          minWidth: 180,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "City",
          field: "city",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "State",
          field: "state",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "Created",
          field: "createdAt",
          minWidth: 140,
          valueFormatter: (p) => {
            if (!p.value) return "-";
            const d = new Date(p.value);
            return `${String(d.getDate()).padStart(2, "0")}-${String(
              d.getMonth() + 1,
            ).padStart(2, "0")}-${d.getFullYear()}`;
          },
        },

        { headerName: "User", field: "userId.name", minWidth: 180 },
        { headerName: "User Email", field: "userId.email", minWidth: 220 },
      ],
    };
  },

  computed: {
    customers() {
      return this.$store.state.customers.customers;
    },

    mobileCard() {
      return {
        title: (row) => row.name || "-",
        subtitle: (row) => row.email || row.phone || "-",
        fields: (row) => [
          { label: "Phone", value: row.phone || "-" },
          { label: "City", value: row.city || "-" },
        ],
        actions: (row) => [
          {
            label: "Invoices",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `customers/${row._id}/invoices` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `customers/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchCustomers();
  },

  methods: {
    async fetchCustomers() {
      this.loading = true;
      try {
        await this.$store.dispatch("customers/getCustomers");
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "customers/create" });
    },
  },
};
</script>
